import React from 'react';
import { resolveStaticUrl } from '../../utils/staticAssets.js';

const HERO_IMAGE = resolveStaticUrl('images/hero.jpg');

const infoByVariant = {
  login: {
    icon: 'key',
    title: 'Acceso restringido',
    message: 'Inicia sesión con tu cuenta autorizada para generar pronósticos.'
  },
  'no_restaurant': {
    icon: 'map-pin',
    title: 'Selecciona un restaurante',
    message: 'Elige una sucursal asignada para continuar con la configuración del pronóstico.'
  },
  error: {
    icon: 'alert-triangle',
    title: 'Ocurrió un error',
    message: 'Intenta nuevamente más tarde.'
  },
  info: {
    icon: 'info',
    title: 'Configuración requerida',
    message: 'Define los parámetros del panel izquierdo para generar tu pronóstico.'
  }
};

const DashboardPlaceholder = ({ placeholder }) => {
  const variant = placeholder?.variant || 'welcome';

  if (variant === 'welcome') {
    return (
      <div
        className="welcome-hero"
        role="region"
        aria-label="Bienvenida Hat Trick"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
      >
        <div className="welcome-hero__overlay" aria-hidden="true" />
        <div className="welcome-hero__content">
          <span className="welcome-hero__eyebrow">Bienvenido</span>
          <h2 className="welcome-hero__title">Hat Trick · Tres pilares.</h2>
          <p className="welcome-hero__subtitle">
            Hospitalidad, calidad y rapidez con IA. Configura el panel izquierdo cuando quieras pronosticar.
          </p>
        </div>
      </div>
    );
  }

  const meta = infoByVariant[variant] || {};
  const icon = placeholder?.icon || meta.icon || 'info';
  const title = placeholder?.title || meta.title || 'Información';
  const message = placeholder?.message || meta.message || '';

  const renderAction = () => {
    if (!placeholder?.action) {
      return null;
    }
    if (placeholder.action.type === 'reload') {
      return (
        <button
          type="button"
          className="btn-primary"
          onClick={() => window.location.reload()}
        >
          Reintentar
        </button>
      );
    }
    if (placeholder.action.type === 'link' && placeholder.action.href) {
      return (
        <a href={placeholder.action.href} className="btn-primary">
          {placeholder.action.label || 'Ver más'}
        </a>
      );
    }
    return null;
  };

  return (
    <div className="placeholder-message">
      <div className="placeholder-icon">
        <i data-lucide={icon} />
      </div>
      <h3>{title}</h3>
      <p>{message}</p>
      {renderAction()}
    </div>
  );
};

export default DashboardPlaceholder;
